import React from 'react';
import styled from '@emotion/styled';
import Button from '../../../components/Button';

import { useGlobalContext } from '../../state/GlobalContext';

interface PuaseButtonProps {
  subscription: Subscription;
  handleStubDataChanges: () => void;
  onPauseModalOpen: () => void;
  t: (key: string) => string;
  isStubbedData?: boolean;
}

const PauseButton = ({
  subscription,
  isStubbedData,
  handleStubDataChanges,
  onPauseModalOpen,
  t,
}: PuaseButtonProps): React.ReactElement | null => {
  const { customerPortalSettings } = useGlobalContext();

  const isActive = subscription?.SubscriptionStatus === 'ACTIVE';
  const merchantSettingHidePause = customerPortalSettings?.hidePause;
  const isPrepaidV2 = subscription?.Lines?.some(({ PrepaidV2 }) => PrepaidV2);
  const isBillingOrUpdatingOrScheduled =
    subscription?.IsBilling ||
    subscription?.IsUpdating ||
    subscription?.IsBillingScheduled;

  return isActive &&
    !isPrepaidV2 &&
    !isBillingOrUpdatingOrScheduled &&
    !merchantSettingHidePause ? (
    <CustomButton
      className="bundle-button--pause"
      outlined
      fullWidth
      onClick={() => {
        isStubbedData ? handleStubDataChanges() : onPauseModalOpen();
      }}
    >
      {t('subscription.pause_subscription')}
    </CustomButton>
  ) : null;
};

const CustomButton = styled(Button)`
  height: 44px;
  display: flex;
  height: auto;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;

export default PauseButton;
